import { store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

type NotificationParams = {
  type: 'success' | 'danger' | 'info' | 'default' | 'warning';
  message: string;
};

export const normalizeErrorMessage = (message: any): string => {
  if (typeof message === 'string') return message;
  if (message?.message && typeof message.message === 'string') return message.message;
  if (message?.error && typeof message.error === 'string') return message.error;
  if (message == null) return 'Unknown error';
  try {
    return JSON.stringify(message);
  } catch {
    return String(message);
  }
};

const displayNotification = (notificationDetails: NotificationParams) => {
  return store.addNotification({
    message: notificationDetails.message,
    type: notificationDetails.type,
    insert: 'top',
    container: 'top-center',
    animationIn: ['animated', 'fadeIn'],
    animationOut: ['animated', 'fadeOut'],
    dismiss: {
      duration: 4000,
      showIcon: true,
    },
    slidingEnter: {
      duration: 200,
      timingFunction: 'ease-in',
      delay: 0,
    },
    slidingExit: {
      duration: 400,
      timingFunction: 'ease-out',
      delay: 0,
    },
  });
};

export const showWarning = (message: string) => {
  displayNotification({ message, type: 'warning' });
};

export const showError = (message: string | any) => {
  displayNotification({ message: normalizeErrorMessage(message), type: 'danger' });
};

export const safeShowError = (message: any) => {
  try {
    showError(message);
  } catch (err) {
    // If the notification system itself crashes, avoid taking down the page.
    // Still log the underlying error so we can diagnose the root cause.
    // eslint-disable-next-line no-console
    console.error('Failed to display error notification:', err, 'original error:', message);
  }
};

export const showSuccess = (message: string) => {
  displayNotification({ message, type: 'success' });
};